document.addEventListener("DOMContentLoaded", function () {
  const toggleWrapper = document.querySelector(".theme-toggle-wrapper");
  const buttons = document.querySelectorAll(".theme-dropdown button");

  function switchScheme(from, to) {
    document.querySelectorAll(`.${from}`).forEach(el => {
      // Skip anything inside .header__row
      if (el.closest(".header__row")) return;

      el.classList.remove(from);
      el.classList.add(to);
    });
  }

  function setTheme(mode) {
    if (mode === "dark") {
      switchScheme("color-scheme-1", "color-scheme-5");
      localStorage.setItem("theme-mode", "dark");
    } else {
      switchScheme("color-scheme-5", "color-scheme-1");
      localStorage.setItem("theme-mode", "light");
    }
  }

  // Load saved mode
  const savedMode = localStorage.getItem("theme-mode");
  if (savedMode === "dark") {
    setTheme("dark");
  }

  // Dropdown toggle
  toggleWrapper.addEventListener("click", function () {
    toggleWrapper.classList.toggle("active");
  });

  // Button clicks
  buttons.forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      const mode = this.dataset.mode;
      setTheme(mode);
      toggleWrapper.classList.remove("active");
    });
  });

  // Close when clicking outside
  document.addEventListener("click", function (e) {
    if (!toggleWrapper.contains(e.target)) {
      toggleWrapper.classList.remove("active");
    }
  });
}); 